export const environment = {
  production: false,
  clientCode: 'DEFAULT',
  usePortals: false,
  includeOngoing: true,
  baseUrl: 'https://localhost:4200',
  backendUrl: 'http://localhost:4000',
  viper: {
    apiUrl: 'https://basic-api-acc.viper365.nl',
    apiKey: 'A20EC0A0-F5F2-4499-96B0-10370A8E7854'
  },
  buckaroo: {
    currency: 'EUR',
    secretKey: 'pegasus',
    url: 'testcheckout.buckaroo.nl',
    websiteKey: 'xOFmVjxBBk'
  },
  paymentType: 'incasso' // 'invoice', 'ideal' or 'incasso'
};
